<template>
  <!--
    PoolaFestivalSavings — the member's personal "وفّرت {amount} ببولشيرك في الموسم
    ده" running-savings line (festival P2-B). {amount} is the REAL per-member
    figure from meta.festival.mySeasonSavingsCents (== data.attributes
    .myPoolshareUsedCents) — never fabricated. Member (seller) viewer only, which
    is inherent: this only ever mounts inside PoolaRun (the buy path). Hidden until
    the member has actually saved something (> 0), so a fresh member never sees a
    hollow «وفّرت 0».
  -->
  <p v-if="amountCents != null && amountCents > 0" class="poola-savings">
    <i18n-t keypath="poola.festival.savings.running" tag="span" scope="global">
      <template #amount>
        <poola-odometer
          class="poola-savings__amount"
          :value="amountCents"
          :text="formatCurrency(amountCents)"
        ></poola-odometer>
      </template>
    </i18n-t>
  </p>
</template>

<script setup>
import { I18nT } from 'vue-i18n';
import PoolaOdometer from './PoolaOdometer.vue';
import { useCurrency } from '@/composables/useCurrency.js';

defineProps({
  // meta.festival.mySeasonSavingsCents — this member's PoolShare-covered amount
  // this run. null/absent or 0 → the line hides.
  amountCents: {
    type: Number,
    default: null,
  },
});

const { formatCurrency } = useCurrency();
</script>

<style scoped>
.poola-savings {
  margin: 0;
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  padding: 5px 14px;
  border-radius: var(--poolit-radius-full);
  background: var(--poolit-primary-100);
  color: var(--poolit-primary-700);
  font-size: var(--poolit-font-size-caption);
  font-weight: var(--poolit-font-weight-semibold);
}

.poola-savings__amount {
  font-weight: var(--poolit-font-weight-bold);
}
</style>
